module.exports = __webpack_public_path__ + "img/40.9fa619c9.svg";